import { Theme } from "../app/interfaces/theme.model";
import { LonaciTheme } from "./theme_lonaci";
import { LonaguiTheme } from "./theme_lonagui";
import { LonaniTheme } from "./theme_lonani";
import { PmucTheme } from "./theme_pmuc";
import { PmucVirtualTheme } from "./theme_pmuc_virtual";
import { PmugTheme } from "./theme_pmug";
import { TunisiaTheme } from "./theme_tunisia";

export const lonagui: Theme = LonaguiTheme;

export const lonani: Theme = LonaniTheme;

export const pmug: Theme = PmugTheme;

export const pmuc: Theme = PmucTheme;

export const lonaci: Theme = LonaciTheme;

export const tunisia: Theme = TunisiaTheme;
export const pmucVitual: Theme = PmucVirtualTheme;

export const SELECTED_THEME: Theme = LonaciTheme;
